import * as React from 'react';
import { Search } from 'react-feather';
import { isDate, isFunction } from 'vega';
import { stringify } from 'vega-tooltip';
import './index.css';
const MAX_DEPTH = 3;
const MAX_LENGTH = 150;
export default class Table extends React.PureComponent {
    render() {
        let { header } = this.props;
        const { data, onClickHandler } = this.props;
        const singleColumn = this.props.header.length == 0;
        if (singleColumn) {
            header = ['datum'];
        }
        const headerNodes = header.map((h) => (React.createElement("th", { onClick: () => onClickHandler && onClickHandler(h), key: h },
            h,
            React.createElement(Search, null))));
        const tableBody = data.map((row, i) => {
            if (singleColumn) {
                row = { datum: row };
            }
            const rowNodes = header.map((field, j) => {
                let tooLong = false;
                let formatted = '';
                if (!isDate(row[field])) {
                    tooLong = formatValueLong(row[field]).tooLong;
                    formatted = formatValueLong(row[field]).formatted;
                }
                else {
                    tooLong = false;
                    formatted = new Date(row[field]).toUTCString();
                }
                const key = `${field} ${j}`;
                if (tooLong) {
                    return (React.createElement("td", { key: key, title: "The field is too large to be displayed. Please use the view API (see JS console)." },
                        React.createElement("span", null, "(...)")));
                }
                else {
                    return React.createElement("td", { key: key }, formatted);
                }
            });
            return React.createElement("tr", { key: i }, rowNodes);
        });
        return (React.createElement("table", { className: "editor-table" },
            React.createElement("thead", null,
                React.createElement("tr", null, headerNodes)),
            React.createElement("tbody", null, tableBody)));
    }
}
function formatNumberValue(value) {
    return isNaN(value)
        ? 'NaN'
        : value === Number.POSITIVE_INFINITY
            ? 'Infinity'
            : value === Number.NEGATIVE_INFINITY
                ? '-Infinity'
                : stringify(value, MAX_DEPTH);
}
export function formatValueLong(value) {
    const formatted = value === undefined
        ? 'undefined'
        : typeof value == 'number'
            ? formatNumberValue(value)
            : isFunction(value)
                ? value.toString()
                : stringify(value, MAX_DEPTH);
    if (formatted.length > MAX_LENGTH) {
        return { formatted: null, tooLong: true };
    }
    return { formatted, tooLong: false };
}
